<template>
  <div class="block block-rounded block-fx-shadow block-mode-loading-refresh" :class="{'block-mode-loading': isProcessing}">
    <div class="block-header">
        <h3 class="block-title">
            {{ $t('app.action') }} <small v-if="filter.period_start_date != ''">c {{filter.period_start_date | dateFormat}} по {{filter.period_end_date | dateFormat}}</small>
        </h3>
        <div class="block-options">
            <button type="button" class="btn-block-option" @click="fetchStats()">
                <i class="si si-refresh"></i>
            </button>
            <date-picker-drop v-model="range" :filter="filter" @datepick="fetchStats()" />
        </div>
    </div>
    <div class="block-content block-content-full">
        <div class="pull-all">
          <line-chart :chart-data="datacollection" :options="chartOptions" :height="120"></line-chart>
        </div>
    </div>
  </div>
</template>

<script>
import LineChart from '../../../partials/charts/LineChart.js';
import moment from 'moment';

export default {
  components: {
    LineChart,
  },
  props: [
    'userId',
  ],
  data() {
    return {
      isProcessing: false,
      datacollection: null,
      filter: {
        period_start_date: moment().startOf('month').format('YYYY-MM-DD'),
        period_end_date: moment().endOf('month').format('YYYY-MM-DD'),
        user_id: this.userId,
      },
      range: [],
      chartOptions: {
        responsive: true,
        maintainAspectRation: true,
        legend: {
          display: true,
          position: 'top',
          labels: {
            usePointStyle: true,
          },
        },
        spanGaps: false,
        elements: {
          line: {
            tension: 0.000001,
            borderWidth: 2,
          },
          point: {
            radius: 5,
            hoverRadius: 7,
          },
        },
      },
    };
  },
  mounted() {
    this.fetchStats();
  },
  methods: {
    fetchStats() {
      this.isProcessing = true;
      window.axios.get('/admin/charts/comments', { params: this.filter })
        .then((res) => {
          this.datacollection = res.data.chartdata;
          this.isProcessing = false;
        });
    },
  },
  watch: {
    range(newValue) {
      if (newValue[0]) {
        this.filter.period_start_date = newValue[0];
      } else {
        this.filter.period_start_date = '';
      }
      if (newValue[1]) {
        this.filter.period_end_date = newValue[1];
      } else {
        this.filter.period_end_date = '';
      }
    },
  },
};
</script>
